import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  number: '01',
  title: 'La Calculadora Cero-Desperdicio (ARS) + Cotizador Instantáneo',
  desc: 'Cotizá cualquier mueble plegable en 3 minutos. Presupuesto en 3 niveles listo para mandar por WhatsApp. 10 ejemplos completos con números reales.',
  value: '$35.000'
}, {
  number: '02',
  title: 'Lista Maestra de Herrajes Plegables (Argentina) + Sustitutos',
  desc: 'Los 20 herrajes que resuelven el 90% de los proyectos. Tabla de sustitutos cuando no hay stock. Checklist de compra imprimible para ir y volver en una sola salida.',
  value: '$28.000'
}, {
  number: '03',
  title: 'Checklist Anti-Errores de Corte y Armado — El Protocolo 1 Tablero',
  desc: 'El protocolo exacto para medir, cortar, etiquetar, probar en seco y recién después atornillar. Evitá el error que más plata quema antes de cortar la primera pieza.',
  value: '$25.000'
}, {
  number: '04',
  title: 'Pack de Textos y Scripts de Venta (WhatsApp + Marketplace + IG)',
  desc: '60 mensajes listos para copiar y pegar. Respuestas a las 10 objeciones más frecuentes. 5 descripciones de producto para publicar hoy mismo. Cierre con anticipo sin fricción.',
  value: '$32.000'
}, {
  number: '05',
  title: 'Plantillas Imprimibles: Jigs y Guías de Perforado (Precisión Rápida)',
  desc: '6 plantillas a escala real para instalar bisagras, rieles, ruedas, soportes y pasacables como fábrica. Instrucciones para fabricar tus propios jigs de taller permanentes.',
  value: '$22.000'
}, {
  number: '06',
  title: 'Guía Express de Instalación Segura (Paredes Reales de Argentina)',
  desc: 'Cómo identificar mampostería, durlock y madera en 3 minutos. Tabla de anclajes por pared y carga. Protocolo anti-vibración. Hoja de relevamiento imprimible para cada instalación.',
  value: '$28.000'
}];
export function Bonuses() {
  return <section className="py-20 bg-white" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-17">
          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-20 h-20 bg-amber/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-18">
            <Gift className="w-10 h-10 text-amber-dark" data-id="element-19" />
          </motion.div>
          <h2 className="text-3xl md:text-5xl font-black text-wood-dark mb-4" data-id="element-20">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="text-xl text-wood-medium italic" data-id="element-21">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-16" data-id="element-22">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-dark border border-wood-light/20 rounded-2xl p-6 md:p-8 flex flex-col h-full relative overflow-hidden group hover:shadow-warm transition-all" data-id="element-23">
              <div className="absolute -right-4 -top-4 text-9xl font-black text-wood-light/5 group-hover:text-amber/10 transition-colors pointer-events-none" data-id="element-24">
                {bonus.number}
              </div>

              <div className="flex items-center mb-4 relative z-10" data-id="element-25">
                <span className="bg-amber text-wood-dark font-bold px-3 py-1 rounded-md text-sm mr-3" data-id="element-26">
                  BONO {parseInt(bonus.number)}
                </span>
              </div>

              <h3 className="text-xl font-bold text-wood-dark mb-3 relative z-10" data-id="element-27">
                {titleFormatter(bonus.title)}
              </h3>

              <p className="text-charcoal/70 mb-6 flex-grow relative z-10" data-id="element-28">
                {bonus.desc}
              </p>

              <div className="mt-auto pt-4 border-t border-wood-light/20 flex items-center justify-between relative z-10" data-id="element-29">
                <span className="text-wood-medium/60 line-through font-medium" data-id="element-30">
                  {bonus.value}
                </span>
                <span className="text-green-600 font-black text-lg flex items-center" data-id="element-31">
                  <Check className="w-5 h-5 mr-1" data-id="element-32" /> GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-amber/10 border-2 border-amber border-dashed rounded-2xl p-8 text-center" data-id="element-33">
          <p className="text-lg text-wood-dark font-medium mb-2" data-id="element-34">
            VALOR TOTAL DE LOS 6 BONOS
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-35">
            <span className="text-2xl text-wood-medium/60 line-through font-bold" data-id="element-36">
              ~~$170.000~~
            </span>
            <span className="text-3xl md:text-4xl font-black text-green-600" data-id="element-37">
              GRATIS
            </span>
          </div>
          <p className="mt-4 text-wood-dark/80 font-medium" data-id="element-38">
            Incluidos siempre en las dos ofertas
          </p>
        </motion.div>
      </div>
    </section>;
}
// Helper to style the title
function titleFormatter(title: string) {
  const parts = title.split('—');
  if (parts.length > 1) {
    return <>
        {parts[0]} <span className="text-amber-dark" data-id="element-39">— {parts[1]}</span>
      </>;
  }
  return title;
}